module.exports = __webpack_public_path__ + "static/gender_card_img2@2x-e49182c46d7236c1bbf7bcca44c4c274.jpg";